import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { CollapsableContainer } from "@ryde/controls";
import {
  editFormDataAF,
  IRideDto,
  resolveRideEditFormCreatedBy,
  RideCrudModeKeyTuple,
  useFormats,
} from "@ryde/shared";

import { useRideTabsBottomBlocksExpand } from "./hooks/use-ride-tabs-bottom-blocks-expand";
import { RideTabsBottomBlocksDetails } from "./ride-tabs-bottom-blocks-details";
import { RideTabsBottomBlocksExpandToggle } from "./ride-tabs-bottom-blocks-expand-toggle";
import {
  RideTabsBottomBlocksHeaderStyled,
  RideTabsBottomBlocksStyled,
} from "./ride-tabs-bottom-blocks.styled";
import { RideBottomBlockStyled } from "./ride.styled";

export const RideTabsBottomBlocks: FC = () => {
  const rideDto = useRecoilValue<Partial<IRideDto> | undefined>(
    editFormDataAF(RideCrudModeKeyTuple),
  );

  const { createdAt, updatedUserId, updatedUserName } = rideDto ?? {};

  const { getFormattedEditUserInfo } = useFormats();
  const { t } = useTranslation();
  const { isExpanded, toggleExpanded } = useRideTabsBottomBlocksExpand();

  const createByLabel = resolveRideEditFormCreatedBy(rideDto, t);
  const createdAtFormatted = getFormattedEditUserInfo(createByLabel, createdAt);
  const updatedAt = getFormattedEditUserInfo(
    updatedUserName ? updatedUserName : `${updatedUserId}`,
    rideDto?.updatedAt,
  );

  return (
    <RideTabsBottomBlocksStyled>
      <RideTabsBottomBlocksHeaderStyled>
        <RideBottomBlockStyled>
          <label>{t("general.CREATED_AT")}</label>
          <span>{createdAtFormatted}</span>
        </RideBottomBlockStyled>
        <RideBottomBlockStyled>
          <label>{t("general.UPDATED_AT")}</label>
          <span>{updatedAt}</span>
        </RideBottomBlockStyled>
        <RideTabsBottomBlocksExpandToggle
          isExpanded={isExpanded}
          onToggle={toggleExpanded}
        />
      </RideTabsBottomBlocksHeaderStyled>
      <CollapsableContainer isCollapsed={isExpanded} isSkipMaxHeight>
        <RideTabsBottomBlocksDetails />
      </CollapsableContainer>
    </RideTabsBottomBlocksStyled>
  );
};
